module.exports = __webpack_public_path__ + "static/media/calculation.051d26a8.svg";